/**
 * Screenshot deterrent, switched on by SCREENSHOT_PROTECTION on the server. A web page cannot truly
 * block a screenshot (a phone camera, the OS tools); this hides the page when the window loses focus
 * or the tab is hidden, blanks it for the Print Screen and Cmd+Shift capture keys, empties the
 * clipboard, and stops printing, saving, copying and the context menu.
 */
const on = (t: EventTarget, e: string, f: (ev: Event) => void) => t.addEventListener(e, f, true);

void fetch('/api/v1/public/config')
  .then((r) => (r.ok ? (r.json() as Promise<{ screenshotProtection?: boolean }>) : null))
  .then((c) => {
    if (c?.screenshotProtection !== true) return;
    const root = document.documentElement;
    root.classList.add('no-capture');
    const hide = (ms = 0) => {
      root.classList.add('no-capture--hidden');
      if (ms > 0) setTimeout(show, ms);
    };
    const show = () => {
      if (document.hasFocus() && !document.hidden) root.classList.remove('no-capture--hidden');
    };
    if (!document.hasFocus()) hide();
    on(window, 'blur', () => hide());
    on(window, 'focus', show);
    on(document, 'visibilitychange', () => (document.hidden ? hide() : show()));
    on(document, 'contextmenu', (e) => e.preventDefault());
    on(document, 'copy', (e) => e.preventDefault());
    on(document, 'dragstart', (e) => e.preventDefault());
    on(window, 'beforeprint', () => hide());
    on(window, 'afterprint', show);
    const key = (e: Event) => {
      const k = e as KeyboardEvent;
      const mod = k.ctrlKey || k.metaKey;
      const capture = k.key === 'PrintScreen' || (k.metaKey && k.shiftKey);
      if (capture) {
        hide(1500);
        void navigator.clipboard?.writeText('').catch(() => undefined);
      }
      if (mod && ['p', 's'].includes(k.key.toLowerCase())) {
        k.preventDefault();
        hide(600);
      }
    };
    on(window, 'keydown', key);
    on(window, 'keyup', key);
  })
  .catch(() => undefined);
